// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__szZk4","xl":"Heading_xl__Pa9YJ","lg":"Heading_lg__hBSit","md":"Heading_md__lUuSC","sm":"Heading_sm__ytNHF","xs":"Heading_xs__lnn1V"};